
/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../../constants";
import { fetchData } from "../../../../helpers";

// ADDREFERRALSSECTION
// ADDREFERRALSSECTION


const ADDREFERRALSSECTION= createAsyncThunk(
  "addReferralSection/addReferralSection",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const addReferralSectionSlice = createSlice({
  name: "addReferralSectionSlice",
  initialState: {
    addReferralSection: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfaddReferralSection: (state) => {
        state.addReferralSection.loading = false
        state.addReferralSection.error = false
        state.addReferralSection.data = []
        state.addReferralSection.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(ADDREFERRALSSECTION.fulfilled, (state, action) => {
      state.addReferralSection = {
        ...state.addReferralSection,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(ADDREFERRALSSECTION.pending, (state, action) => {
      state.addReferralSection = {
        ...state.addReferralSection,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(ADDREFERRALSSECTION.rejected, (state, action) => {
      state.addReferralSection = {
        ...state.addReferralSection,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const addReferralSectionAction = {
    ADDREFERRALSSECTION,
};

export { addReferralSectionAction };
export default addReferralSectionSlice.reducer;
export const {setInitialStateOfaddReferralSection} = addReferralSectionSlice.actions
